(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function parseMoney(str) {
    if (str == null) return 0;
    var s = String(str).trim().replace(/[^\d.,-]/g, '');
    if (!s) return 0;

    // Handle negatives
    var neg = false;
    if (s[0] === '-') {
      neg = true;
      s = s.slice(1);
    }

    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    var decPos = Math.max(lastDot, lastComma);

    var num;
    if (decPos > -1) {
      var intPart = s.slice(0, decPos).replace(/[.,]/g, '');
      var decPart = s.slice(decPos + 1).replace(/[.,]/g, '');
      num = Number(intPart + '.' + decPart);
    } else {
      num = Number(s.replace(/[.,]/g, ''));
    }

    if (isNaN(num)) return 0;
    return neg ? -num : num;
  }

  function formatMoney(value, currencyCode) {
    var lang = document.documentElement.getAttribute('lang') || navigator.language || 'en-US';
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: currencyCode || 'EUR'
      }).format(value);
    } catch (e) {
      // Fallback
      var v = Math.round(value * 100) / 100;
      return (currencyCode ? currencyCode + ' ' : '') + v.toFixed(2);
    }
  }

  function isIgnorableClickTarget(target) {
    if (!target) return false;
    // Anything interactive should NOT trigger "navigate card"
    return !!target.closest('a,button,input,select,textarea,summary,details,[role="button"],[data-ignore-order-click],.celvian-orders-list__actions,.celvian-actions-menu');
  }

  onReady(function () {
    // Exposed closers so drawers can mutually close without brittle coupling.
    var closeUserMenu = function () {};
    var closeMobileDrawer = function () {};
    var isMobileDrawerOpen = function () { return false; };
    var closeOrdersFilterDrawer = function () {};

    // =========================
    // Desktop user dropdown menu - FIXED: Click outside to close
    // =========================
    (function () {
      var btn = document.querySelector('[data-celvian-account-avatar]');
      var menu = document.querySelector('[data-celvian-account-menu]');
      if (!btn || !menu) return;

      closeUserMenu = function () {
        menu.style.animation = 'menuFadeOut 0.2s ease';
        setTimeout(function() {
          menu.setAttribute('hidden', 'hidden');
          menu.style.animation = '';
          btn.setAttribute('aria-expanded', 'false');
        }, 200);
      };

      var openUserMenu = function () {
        // mutual close: if orders filter is open, close it
        closeOrdersFilterDrawer();
        // mutual close: if mobile drawer is open, close it
        closeMobileDrawer();

        menu.removeAttribute('hidden');
        menu.style.animation = 'menuFadeIn 0.2s ease';
        btn.setAttribute('aria-expanded', 'true');
      };

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (menu.hasAttribute('hidden')) openUserMenu();
        else closeUserMenu();
      });

      // Close menu when clicking anywhere
      document.addEventListener('click', function (e) {
        if (menu.hasAttribute('hidden')) return;
        if (btn.contains(e.target) || menu.contains(e.target)) return;
        closeUserMenu();
      });

      // Close menu on escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hasAttribute('hidden')) {
          closeUserMenu();
        }
      });
    })();

    // =========================
    // Mobile drawer (hamburger) - FIXED: Click outside to close
    // =========================
    (function () {
      var openBtn = document.querySelector('[data-celvian-drawer-open]');
      var closeBtn = document.querySelector('[data-celvian-drawer-close]');
      var overlay = document.querySelector('[data-celvian-drawer-overlay]');
      var drawer = document.querySelector('[data-celvian-drawer]');

      isMobileDrawerOpen = function () {
        return document.body.classList.contains('celvian-drawer-open');
      };

      var openDrawer = function () {
        if (!drawer || !overlay) return;

        // mutual close: close orders filter + desktop user menu
        closeOrdersFilterDrawer();
        closeUserMenu();

        overlay.hidden = false;
        drawer.hidden = false;
        requestAnimationFrame(function () {
          document.body.classList.add('celvian-drawer-open');
        });
      };

      closeMobileDrawer = function () {
        if (!drawer || !overlay) return;
        if (!document.body.classList.contains('celvian-drawer-open')) return;
        
        document.body.classList.remove('celvian-drawer-open');
        setTimeout(function () {
          overlay.hidden = true;
          drawer.hidden = true;
        }, 300);
      };

      if (openBtn) {
        openBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openDrawer();
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeMobileDrawer();
        });
      }

      if (overlay) {
        overlay.addEventListener('click', function (e) {
          e.stopPropagation();
          closeMobileDrawer();
        });
      }

      // Close drawer when user clicks any nav link inside it
      if (drawer) {
        drawer.addEventListener('click', function (e) {
          var t = e.target;
          if (!t) return;
          if (t.tagName && t.tagName.toLowerCase() === 'a' && isMobileDrawerOpen()) {
            closeMobileDrawer();
          }
        });
      }

      // Close drawer when clicking outside (even if overlay doesn't catch it)
      document.addEventListener('click', function (e) {
        if (!isMobileDrawerOpen()) return;
        if (openBtn && openBtn.contains(e.target)) return;
        if (drawer && drawer.contains(e.target)) return;
        if (overlay && overlay.contains(e.target)) return;
        closeMobileDrawer();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isMobileDrawerOpen()) {
          e.preventDefault();
          closeMobileDrawer();
        }
      });
    })();

    // ============================================
    // Active nav + Account view switching (?view=)
    // ============================================
    (function () {
      var setNavActive = function (key) {
        document.querySelectorAll('[data-celvian-account-nav] a').forEach(function (a) {
          a.classList.remove('is-active');
        });
        document.querySelectorAll('[data-celvian-nav-view="' + key + '"]').forEach(function (link) {
          link.classList.add('is-active');
        });
      };

      var views = document.querySelectorAll('[data-celvian-account-view]');
      if (views && views.length) {
        var params = new URLSearchParams(window.location.search);
        var activeView = params.get('view') || 'orders';

        views.forEach(function (el) {
          var v = el.getAttribute('data-celvian-account-view');
          if (v === activeView) el.removeAttribute('hidden');
          else el.setAttribute('hidden', 'hidden');
        });

        setNavActive(activeView);
      } else {
        var p = window.location.pathname || '';
        if (p.indexOf('/account') === 0) setNavActive('orders');
      }
    })();

    // =========================
    // Orders: view switch + filter/sort drawer - FIXED: Radio button selection
    // =========================
    (function () {
      var root = document.querySelector('[data-celvian-orders]');
      if (!root) return;

      var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

      var gallery = root.querySelector('[data-celvian-orders-gallery]');
      var list = root.querySelector('[data-celvian-orders-list]');

      // ---- View switcher (desktop only)
      var viewBtn = root.querySelector('[data-celvian-orders-view-btn]');
      var viewMenu = root.querySelector('[data-celvian-orders-view-menu]');
      var viewLabel = root.querySelector('[data-celvian-orders-view-label]');

      var viewIcon = root.querySelector('[data-celvian-orders-view-icon]') || root.querySelector('.celvian-orders-view__icon');

      var ICON_GALLERY = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>';
      var ICON_LIST = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3" y2="6"></line><line x1="3" y1="12" x2="3" y2="12"></line><line x1="3" y1="18" x2="3" y2="18"></line></svg>';

      function setViewButtonUI(v) {
        if (viewLabel) viewLabel.textContent = (v === 'list') ? 'List' : 'Gallery';
        if (viewIcon) viewIcon.innerHTML = (v === 'list') ? ICON_LIST : ICON_GALLERY;
      }

      var view = 'gallery';
      try { view = localStorage.getItem('celvian_orders_view') || 'gallery'; } catch (_) {}

      function closeViewMenu() {
        if (!viewMenu || !viewBtn) return;
        viewMenu.hidden = true;
        viewBtn.setAttribute('aria-expanded', 'false');
      }

      function applyView() {
        if (!gallery || !list) return;
        var v = isDesktop() ? view : 'gallery';

        if (v === 'list') {
          list.hidden = false;
          gallery.style.display = 'none';
        } else {
          list.hidden = true;
          gallery.style.display = '';
        }

        setViewButtonUI(v);
      }

      if (viewBtn && viewMenu) {
        function openViewMenu() {
          // mutual close
          closeOrdersFilterDrawer();
          closeUserMenu();
          closeMobileDrawer();

          viewMenu.hidden = false;
          viewBtn.setAttribute('aria-expanded', 'true');
        }

        viewBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (viewMenu.hidden) openViewMenu();
          else closeViewMenu();
        });

        viewMenu.addEventListener('click', function (e) {
          var t = e.target;
          if (!t) return;
          var b = t.closest('button[data-view]');
          if (!b) return;
          view = b.getAttribute('data-view') || 'gallery';
          try { localStorage.setItem('celvian_orders_view', view); } catch (_) {}
          closeViewMenu();
          applyView();
        });

        document.addEventListener('click', function (e) {
          if (!viewMenu || viewMenu.hidden) return;
          if (viewBtn.contains(e.target) || viewMenu.contains(e.target)) return;
          closeViewMenu();
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && viewMenu && !viewMenu.hidden) {
            closeViewMenu();
          }
        });
      }

      // ---- Sort/filter drawer - FIXED: Radio button styling and selection
      var openBtn = root.querySelector('[data-celvian-orders-filter-open]');
      var closeBtn = root.querySelector('[data-celvian-orders-filter-close]');
      var overlay = root.querySelector('[data-celvian-orders-filter-overlay]');
      var drawer = root.querySelector('[data-celvian-orders-filter]');
      var applyBtn = root.querySelector('[data-celvian-orders-apply]');
      var resetBtn = root.querySelector('[data-celvian-orders-reset]');

      var customWrap = root.querySelector('[data-celvian-orders-custom-range]');
      var startInput = root.querySelector('[data-celvian-orders-start]');
      var endInput = root.querySelector('[data-celvian-orders-end]');

      // Tabs (Sort / Filter)
      var tabBtns = drawer ? drawer.querySelectorAll('[data-celvian-sf-tab]') : [];
      var panels = drawer ? drawer.querySelectorAll('[data-celvian-sf-panel]') : [];

      function setTab(key) {
        if (!drawer) return;

        tabBtns.forEach(function (b) {
          var k = b.getAttribute('data-celvian-sf-tab');
          var active = k === key;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          var pk = p.getAttribute('data-celvian-sf-panel');
          p.hidden = pk !== key;
        });
      }

      // Function to update radio button UI
      function updateRadioButtonUI() {
        if (!drawer) return;
        
        // Update sort radio buttons
        var sortRadios = drawer.querySelectorAll('input[name="celvian_sort"]');
        sortRadios.forEach(function(radio) {
          var label = radio.closest('.celvian-radio-label');
          if (!label) return;
          
          if (radio.checked) {
            label.classList.add('is-selected');
            label.style.backgroundColor = 'rgba(10, 102, 255, 0.05)';
            label.style.borderColor = 'rgba(10, 102, 255, 0.2)';
          } else {
            label.classList.remove('is-selected');
            label.style.backgroundColor = '';
            label.style.borderColor = 'transparent';
          }
        });
        
        // Update date radio buttons
        var dateRadios = drawer.querySelectorAll('input[name="celvian_date"]');
        dateRadios.forEach(function(radio) {
          var label = radio.closest('.celvian-radio-label');
          if (!label) return;
          
          if (radio.checked) {
            label.classList.add('is-selected');
            label.style.backgroundColor = 'rgba(10, 102, 255, 0.05)';
            label.style.borderColor = 'rgba(10, 102, 255, 0.2)';
          } else {
            label.classList.remove('is-selected');
            label.style.backgroundColor = '';
            label.style.borderColor = 'transparent';
          }
        });
      }

      function openDrawer() {
        if (!drawer || !overlay) return;

        // mutual close
        closeMobileDrawer();
        closeUserMenu();
        closeViewMenu();

        // close any open list action menus
        root.querySelectorAll('.celvian-actions-menu').forEach(function (m) { m.hidden = true; });

        overlay.hidden = false;
        drawer.hidden = false;
        setTab('sort');

        // Update radio button UI when drawer opens
        setTimeout(updateRadioButtonUI, 10);

        requestAnimationFrame(function () {
          document.body.classList.add('celvian-orders-filter-open');
        });
      }

      closeOrdersFilterDrawer = function () {
        if (!drawer || !overlay) return;
        if (!document.body.classList.contains('celvian-orders-filter-open')) return;

        document.body.classList.remove('celvian-orders-filter-open');
        setTimeout(function () {
          overlay.hidden = true;
          drawer.hidden = true;
        }, 300);
      };

      if (openBtn) {
        openBtn.addEventListener('click', function (e) { 
          e.preventDefault();
          e.stopPropagation();
          openDrawer(); 
        });
      }
      
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) { 
          e.preventDefault();
          e.stopPropagation();
          closeOrdersFilterDrawer(); 
        });
      }
      
      if (overlay) {
        overlay.addEventListener('click', function (e) { 
          e.stopPropagation();
          closeOrdersFilterDrawer(); 
        });
      }

      // Click outside to close filter drawer
      document.addEventListener('click', function (e) {
        if (!drawer || drawer.hidden) return;
        if (openBtn && openBtn.contains(e.target)) return;
        if (drawer.contains(e.target)) return;
        if (overlay && overlay.contains(e.target)) return;
        closeOrdersFilterDrawer();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer && !drawer.hidden) {
          closeOrdersFilterDrawer();
        }
      });

      if (drawer && tabBtns.length) {
        tabBtns.forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.preventDefault();
            setTab(b.getAttribute('data-celvian-sf-tab') || 'sort');
          });
        });
      }

      // Update radio button UI when radio changes
      if (drawer) {
        drawer.addEventListener('change', function (e) {
          if (e.target.name === 'celvian_sort' || e.target.name === 'celvian_date') {
            updateRadioButtonUI();
            
            // Show/hide custom date range
            if (e.target.name === 'celvian_date' && e.target.value === 'custom') {
              if (customWrap) customWrap.hidden = false;
            } else if (e.target.name === 'celvian_date' && customWrap) {
              customWrap.hidden = true;
            }
          }
        });
        
        // Add hover effect to radio labels
        drawer.addEventListener('mouseover', function(e) {
          var label = e.target.closest('.celvian-radio-label');
          if (label && !label.classList.contains('is-selected')) {
            label.style.backgroundColor = 'rgba(0, 0, 0, 0.02)';
          }
        });
        
        drawer.addEventListener('mouseout', function(e) {
          var label = e.target.closest('.celvian-radio-label');
          if (label && !label.classList.contains('is-selected')) {
            label.style.backgroundColor = '';
          }
        });
      }

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-order]'));

      function getSortValue(el, sortKey) {
        var ts = Number(el.getAttribute('data-order-ts') || 0);
        var num = Number(el.getAttribute('data-order-number') || 0);
        var totalStr = el.getAttribute('data-order-total-str') || '';
        var total = parseMoney(totalStr);
        if (sortKey === 'newest' || sortKey === 'oldest') return ts;
        if (sortKey === 'num_desc' || sortKey === 'num_asc') return num;
        if (sortKey === 'total_desc' || sortKey === 'total_asc') return total;
        return ts;
      }

      function withinDate(el, dateKey, start, end) {
        var ts = Number(el.getAttribute('data-order-ts') || 0);
        if (!ts) return true;

        // No filter selected
        if (!dateKey) return true;

        var now = Math.floor(Date.now() / 1000);

        if (dateKey === 'today') {
          var d = new Date();
          d.setHours(0, 0, 0, 0);
          var from = Math.floor(d.getTime() / 1000);
          return ts >= from && ts <= now;
        }

        if (dateKey === 'custom') {
          if (!start && !end) return true;
          var from2 = start ? Math.floor(new Date(start + 'T00:00:00').getTime() / 1000) : 0;
          var to2 = end ? Math.floor(new Date(end + 'T23:59:59').getTime() / 1000) : now;
          return ts >= from2 && ts <= to2;
        }

        var days = Number(dateKey || 0);
        if (!days) return true;
        var cutoff = now - (days * 86400);
        return ts >= cutoff && ts <= now;
      }

      function renderSortedFiltered() {
        var sortKey = (root.querySelector('input[name="celvian_sort"]:checked') || {}).value || 'newest';
        var dateRadio = root.querySelector('input[name="celvian_date"]:checked');
        var dateKey = dateRadio ? dateRadio.value : '';

        var start = startInput ? startInput.value : '';
        var end = endInput ? endInput.value : '';

        if (customWrap) {
          customWrap.hidden = dateKey !== 'custom';
        }

        var filtered = items.filter(function (el) {
          return withinDate(el, dateKey, start, end);
        });

        filtered.sort(function (a, b) {
          var va = getSortValue(a, sortKey);
          var vb = getSortValue(b, sortKey);
          if (sortKey === 'oldest' || sortKey === 'num_asc' || sortKey === 'total_asc') {
            return va - vb;
          }
          return vb - va;
        });

        var byKey = {};
        filtered.forEach(function (el) {
          var key = el.getAttribute('data-order-ts') + '_' + el.getAttribute('data-order-number');
          byKey[key] = true;
        });

        function reorder(container) {
          if (!container) return;
          var nodes = Array.prototype.slice.call(container.querySelectorAll('[data-order]'));
          var keep = nodes.filter(function (n) {
            var k = n.getAttribute('data-order-ts') + '_' + n.getAttribute('data-order-number');
            return byKey[k];
          });

          nodes.forEach(function (n) {
            var k = n.getAttribute('data-order-ts') + '_' + n.getAttribute('data-order-number');
            n.style.display = byKey[k] ? '' : 'none';
          });

          var frag = document.createDocumentFragment();
          filtered.forEach(function (ref) {
            var k = ref.getAttribute('data-order-ts') + '_' + ref.getAttribute('data-order-number');
            var match = keep.find(function (n) {
              return (n.getAttribute('data-order-ts') + '_' + n.getAttribute('data-order-number')) === k;
            });
            if (match) frag.appendChild(match);
          });
          container.appendChild(frag);
        }

        reorder(root.querySelector('[data-celvian-orders-gallery]'));
        reorder(root.querySelector('[data-celvian-orders-list]'));
      }

      // Show/hide custom immediately
      root.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.name === 'celvian_date') renderSortedFiltered();
      });

      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          renderSortedFiltered();
          closeOrdersFilterDrawer();
        });
      }

      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          // Sort back to newest
          var s1 = root.querySelector('input[name="celvian_sort"][value="newest"]');
          if (s1) s1.checked = true;

          // Clear date selection
          root.querySelectorAll('input[name="celvian_date"]').forEach(function (r) {
            r.checked = false;
          });

          if (startInput) startInput.value = '';
          if (endInput) endInput.value = '';
          if (customWrap) customWrap.hidden = true;

          // Update UI
          updateRadioButtonUI();
          renderSortedFiltered();
        });
      }

      // ---- List actions menu (•••)
      root.querySelectorAll('[data-celvian-order-actions]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var wrap = btn.closest('.celvian-orders-list__actions');
          if (!wrap) return;
          var menu = wrap.querySelector('.celvian-actions-menu');
          if (!menu) return;

          root.querySelectorAll('.celvian-actions-menu').forEach(function (m) {
            if (m !== menu) m.hidden = true;
          });

          menu.hidden = !menu.hidden;
        });
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) return;
        var inside = e.target.closest('.celvian-orders-list__actions');
        if (inside) return;
        root.querySelectorAll('.celvian-actions-menu').forEach(function (m) { m.hidden = true; });
      });

      // ---- Click anywhere on card/row to open order details
      root.addEventListener('click', function (e) {
        var t = e.target;
        if (!t) return;
        var card = t.closest('[data-order][data-order-url]');
        if (!card || !root.contains(card)) return;
        if (isIgnorableClickTarget(t)) return;

        var url = card.getAttribute('data-order-url');
        if (url) window.location.href = url;
      });

      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var t = e.target;
        if (!t) return;
        var card = t.closest('[data-order][data-order-url]');
        if (!card || !root.contains(card)) return;
        if (isIgnorableClickTarget(t)) return;

        e.preventDefault();
        var url = card.getAttribute('data-order-url');
        if (url) window.location.href = url;
      });

      // initial
      applyView();
      renderSortedFiltered();
      window.addEventListener('resize', applyView);
    })();

    // =========================
    // Account Details: Profile editor
    // =========================
    (function () {
      var card = document.querySelector('[data-celvian-profile]');
      if (!card) return;

      var view = card.querySelector('[data-celvian-profile-view]');
      var form = card.querySelector('[data-celvian-profile-form]');
      var editBtn = card.querySelector('[data-celvian-profile-edit]');
      var cancelBtn = card.querySelector('[data-celvian-profile-cancel]');
      var pickBtn = card.querySelector('[data-celvian-profile-pick]');
      var fileInput = card.querySelector('[data-celvian-profile-file]');
      var preview = card.querySelector('[data-celvian-profile-preview]');
      var saveBtn = card.querySelector('[data-celvian-profile-save]');

      if (!view || !form || !editBtn) return;

      var endpoint = '/apps/celvian-returns/profile/update';

      // Local preview URL so user sees avatar instantly (even before Shopify finishes processing)
      var localAvatarPreviewUrl = '';

      function toast(type, title, message) {
        var old = document.querySelector('.celvian-toast');
        if (old) old.remove();

        var t = document.createElement('div');
        t.className = 'celvian-toast celvian-toast--' + (type || 'success');
        t.innerHTML =
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            (type === 'error'
              ? '<path d="M10 1.667c4.6 0 8.333 3.733 8.333 8.333S14.6 18.333 10 18.333 1.667 14.6 1.667 10 5.4 1.667 10 1.667zm0 10a.833.833 0 100 1.666.833.833 0 000-1.666zm0-6.667a.833.833 0 00-.833.834v4.166a.833.833 0 001.666 0V5.834A.833.833 0 0010 5z" fill="currentColor"/>'
              : '<path d="M10 1.667c4.6 0 8.333 3.733 8.333 8.333S14.6 18.333 10 18.333 1.667 14.6 1.667 10 5.4 1.667 10 1.667zm3.933 5.267a.833.833 0 00-1.2-1.15l-3.616 3.767-1.85-1.85a.833.833 0 00-1.178 1.178l2.45 2.45c.325.325.85.325 1.175 0l4.219-4.395z" fill="currentColor"/>'
            ) +
          '</svg>' +
          '<div><strong>' + (title || '') + '</strong><p>' + (message || '') + '</p></div>';

        document.body.appendChild(t);
        setTimeout(function () {
          t.classList.add('celvian-toast--hide');
          setTimeout(function () { t.remove(); }, 300);
        }, 3500);
      }

      function openEdit() {
        if (view) view.hidden = true;
        form.hidden = false;
        card.classList.add('is-profile-editing');
      }

      function closeEdit() {
        form.hidden = true;
        if (view) view.hidden = false;
        card.classList.remove('is-profile-editing');
      }

      editBtn.addEventListener('click', function () {
        openEdit();
      });

      if (cancelBtn) {
        cancelBtn.addEventListener('click', function () {
          closeEdit();
        });
      }

      if (pickBtn && fileInput) {
        pickBtn.addEventListener('click', function () {
          fileInput.click();
        });
      }

      if (fileInput && preview) {
        fileInput.addEventListener('change', function () {
          var file = fileInput.files && fileInput.files[0];
          if (!file) return;
          var url = URL.createObjectURL(file);
          localAvatarPreviewUrl = url;
          preview.innerHTML = '<img src="' + url + '" alt="" loading="lazy">';
        });
      }

      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        if (saveBtn) {
          saveBtn.disabled = true;
          saveBtn.style.opacity = '0.7';
        }

        try {
          var fd = new FormData();
          var first = form.querySelector('input[name="first_name"]');
          var last = form.querySelector('input[name="last_name"]');
          var bday = form.querySelector('input[name="birthday"]');
          var mkt = form.querySelector('input[name="accepts_marketing"]');

          fd.append('first_name', first ? first.value.trim() : '');
          fd.append('last_name', last ? last.value.trim() : '');
          fd.append('accepts_marketing', mkt && mkt.checked ? 'true' : 'false');

          if (bday && !bday.disabled) fd.append('birthday', bday.value || '');
          if (fileInput && fileInput.files && fileInput.files[0]) fd.append('avatar', fileInput.files[0]);

          var res = await fetch(endpoint, { method: 'POST', credentials: 'same-origin', body: fd });

          var data = null;
          try { data = await res.json(); } catch (_) { data = null; }

          if (!res.ok || !data || !data.ok) {
            var msg = (data && (data.error || data.message)) || 'Profile endpoint returned invalid response.';
            toast('error', 'Could not save', msg);
            return;
          }

          var fullName =
            ((data.first_name || '').trim() + ' ' + (data.last_name || '').trim()).trim() ||
            (data.email || '');

          card.querySelectorAll('[data-celvian-profile-name]').forEach(function (el) {
            el.textContent = fullName;
          });

          var bdayEl = card.querySelector('[data-celvian-profile-birthday]');
          if (bdayEl && typeof data.birthday_display === 'string') bdayEl.textContent = data.birthday_display || '—';

          var mktEl = card.querySelector('[data-celvian-profile-marketing]');
          if (mktEl) mktEl.textContent = data.accepts_marketing ? 'Subscribed' : 'Not subscribed';

          // Update header + dropdown + drawer + hero avatar immediately
          try {
            var headerBtn = document.querySelector('[data-celvian-account-avatar]');
            var menuAvatar = document.querySelector('.celvian-account-menu__avatar');
            var drawerAvatar = document.querySelector('.celvian-account-drawer__avatar');

            var fn2 = (data.first_name || '').trim();
            var ln2 = (data.last_name || '').trim();

            var initials2 = '';
            if (fn2 && ln2) initials2 = (fn2[0] + ln2[0]).toUpperCase();
            else if (fn2) initials2 = fn2.slice(0, 2).toUpperCase();
            else initials2 = (data.email || '').slice(0, 2).toUpperCase();

            var avatarUrl2 =
              (typeof data.avatar_url === 'string' && data.avatar_url)
                ? data.avatar_url
                : (localAvatarPreviewUrl || '');

            function setAvatar(el) {
              if (!el) return;
              if (avatarUrl2) el.innerHTML = '<img class="celvian-avatar-img" src="' + avatarUrl2 + '" alt="" loading="lazy">';
              else el.textContent = initials2;
            }

            setAvatar(headerBtn);
            setAvatar(menuAvatar);
            setAvatar(drawerAvatar);

            var heroAvatar = card.querySelector('.celvian-profile__avatar');
            if (avatarUrl2) {
              if (heroAvatar) heroAvatar.innerHTML = '<img src="' + avatarUrl2 + '" alt="" loading="lazy">';
              if (preview) preview.innerHTML = '<img src="' + avatarUrl2 + '" alt="" loading="lazy">';
            }
          } catch (err) {
            // Don’t pretend the save failed just because avatar UI refresh failed
            console.warn('[celvian] avatar UI update failed', err);
          }

          closeEdit();
          toast('success', 'Saved', 'Profile updated.');
        } catch (err) {
          toast('error', 'Could not save', String(err && err.message ? err.message : err));
        } finally {
          if (saveBtn) {
            saveBtn.disabled = false;
            saveBtn.style.opacity = '';
          }
        }
      });

    })();

    // =========================
    // Cookie preferences (best effort)
    // =========================
    (function () {
      var cookieBtn = document.querySelector('[data-celvian-cookie-preferences]');
      if (!cookieBtn) return;

      cookieBtn.addEventListener('click', function (e) {
        e.preventDefault();

        try {
          if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.showPreferences) {
            Shopify.customerPrivacy.showPreferences();
            return;
          }
        } catch (_) {}

        try {
          if (window.privacyBanner && window.privacyBanner.showPreferences) {
            window.privacyBanner.showPreferences();
            return;
          }
        } catch (_) {}

        try {
          var privacy = document.querySelector('[data-privacy-policy-url]');
          if (privacy && privacy.getAttribute('href')) {
            window.location.href = privacy.getAttribute('href');
            return;
          }
        } catch (_) {}

        alert('Cookie preferences can be managed via the cookie banner on your next visit.');
      });
    })();

    // =========================
    // Orders empty state: AJAX quick add (with toast)
    // =========================
    (function () {
      var emptyRoot = document.querySelector('[data-celvian-orders-empty]');
      if (!emptyRoot) return;

      function getRoot() {
        try {
          if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
        } catch (_) {}
        return '/';
      }

      function buildUrl(path) {
        var root = getRoot();
        if (!root.endsWith('/')) root += '/';
        if (path.startsWith('/')) path = path.slice(1);
        return root + path;
      }

      function toast(type, title, message) {
        // Uses your existing .celvian-toast CSS (already in celvian-account.css)
        var el = document.createElement('div');
        el.className = 'celvian-toast celvian-toast--' + (type === 'error' ? 'error' : 'success');
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');

        var icon = (type === 'error')
          ? '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 9v4m0 4h.01M10.3 3.2h3.4L22 20H2L10.3 3.2z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
          : '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        el.innerHTML =
          icon +
          '<div><strong>' + (title || '') + '</strong>' +
          '<div>' + (message || '') + '</div></div>';

        document.body.appendChild(el);

        window.setTimeout(function () {
          el.classList.add('celvian-toast--hide');
          window.setTimeout(function () {
            if (el && el.parentNode) el.parentNode.removeChild(el);
          }, 350);
        }, 2600);
      }

      emptyRoot.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches('[data-celvian-quickadd-form]')) return;

        // If fetch/FormData not available, let the form submit normally.
        if (!window.fetch || !window.FormData) return;

        e.preventDefault();

        var btn = form.querySelector('button[type="submit"]');
        if (!btn) return;

        var original = btn.textContent;
        btn.disabled = true;
        btn.classList.add('is-loading');

        var fd = new FormData(form);
        var addUrl = buildUrl('cart/add.js');

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) throw data;
              return data;
            });
          })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.textContent = 'Added';
            toast('success', 'Added to cart', 'Ready when you are.');

            window.setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1100);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.disabled = false;
            btn.textContent = original;
            toast('error', 'Couldn’t add to cart', 'Try again in a moment.');
          });
      });
    })();

    // =========================
    // Add CSS animations for menus
    // =========================
    var style = document.createElement('style');
    style.textContent = `
      @keyframes menuFadeIn {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      @keyframes menuFadeOut {
        from {
          opacity: 1;
          transform: translateY(0);
        }
        to {
          opacity: 0;
          transform: translateY(-10px);
        }
      }
      
      .celvian-account-menu {
        animation: menuFadeIn 0.2s ease;
      }
      
      .celvian-radio-label {
        transition: all 0.2s ease;
        border: 1px solid transparent;
        border-radius: 8px;
        margin-bottom: 4px;
      }
      
      .celvian-radio-label.is-selected {
        background-color: rgba(10, 102, 255, 0.05) !important;
        border-color: rgba(10, 102, 255, 0.2) !important;
      }
      
      .celvian-radio-label:hover:not(.is-selected) {
        background-color: rgba(0, 0, 0, 0.02);
      }
    `;
    document.head.appendChild(style);
  });
})();